import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';

import iconSet from '../../../../shared/images/teambuildr-selection.json';

const CloseButton = styled('button')`
  align-self: center;
  display: flex;
  align-items: center;
  height: 16px;
  margin-left: 8px;
  margin-bottom: 0;
  border: 0px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
`;

const GroupItem = styled('div')`
  height: 24px;
  line-height: 16px;
  padding: 16px 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: #CFF5E8;
  color: #616161;
  border-radius: 4px;
  margin: 0 0 8px 8px;
  width: fit-content;
`;

const SelectedGroupItem = ({ group, deleteGroup }) => (
  <GroupItem>
    <div>{group.name}</div>
    <CloseButton
      onClick={() => deleteGroup(group.id)}
    >
      <IcomoonReact
        iconSet={iconSet}
        size={10}
        icon='remove'
        color='#444444'
      />
    </CloseButton>
  </GroupItem>
);

export default SelectedGroupItem;

SelectedGroupItem.propTypes = {
  deleteGroup: PropTypes.func.isRequired,
  group: PropTypes.instanceOf(Object).isRequired,
};
